import { BaseFilter } from './base-filter.interface';

export interface FiltroRiepilogoModifiche extends BaseFilter {
  risorsa?: string | null;
  nomeRisorsa?: string | null;
  codiceCommessaSorgente?: string | null;
  descrizioneCommessaSorgente?: string | null;
  codiceCommessaDestinazione?: string | null;
  descrizioneCommessaDestinazione?: string | null;
  codiceUnitaOrganizzativaPrimoLivello?: string | null;
  descrizioneUnitaOrganizzativaPrimoLivello?: string | null;
  nomeApprovatore?: string | null;
  dataApprovazione?: string | null;
}

export const filtroRiepilogoModificheVuoto: FiltroRiepilogoModifiche = {
  risorsa: null,
  nomeRisorsa: null,
  codiceCommessaSorgente: null,
  descrizioneCommessaSorgente: null,
  codiceCommessaDestinazione: null,
  descrizioneCommessaDestinazione: null,
  codiceUnitaOrganizzativaPrimoLivello: null,
  descrizioneUnitaOrganizzativaPrimoLivello: null,
  nomeApprovatore: null,
  dataApprovazione: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};
